import React from 'react';
import * as Yup from 'yup';

import {
  ApplicationFlow,
  TextInput,
} from '../components';
import { documentTypes } from '../data';


const Description = () => (
  <React.Fragment>
    <p>
      A Trust is a legal entity created by a party (the trustor) through which a second party (the trustee) holds the right to manage the trustor's assets or property.
    </p>
  </React.Fragment>
);


const fieldSets = [
  {
    legend: 'Trust Information',
    fields: new Map([
      ['orgName', {
        label: 'Trust Name',
        title: 'Please provide a valid trust name',
        'data-help-title': 'Name of Trust',
        'data-help-text': 'Please provide the name of the trust.',
        validation: Yup.string().required('Please provide a valid trust name'),
      }],
      ['orgType', {
        label: 'Trust Type',
      }],
    ]),
  },
  {
    legend: 'Creator/Grantor Information',
    fields: new Map([
      ['firstName', {
        label: 'Grantor First Name',
        'data-help-title': 'Grantor Information',
        'data-help-text': 'The Grantor is the person or business who is making the grant to create the trust. The Grantor can also sometimes be known as the Owner, Trustor, Donor, Settlor, Conservator, Guardian, or Custodian.<br><br>If there is more than one Grantor, list the primary one. Or if all Grantors are equal, list only one.<br><br>The Grantor and Trustee of a trust may sometimes be the same person.',
      }],
      ['middleName', {
        label: 'Grantor Middle Name',
        'data-help-title': 'Grantor Information',
        'data-help-text': 'The Grantor is the person or business who is making the grant to create the trust. The Grantor can also sometimes be known as the Owner, Trustor, Donor, Settlor, Conservator, Guardian, or Custodian.<br><br>If there is more than one Grantor, list the primary one. Or if all Grantors are equal, list only one.<br><br>The Grantor and Trustee of a trust may sometimes be the same person.',
      }],
      ['lastName', {
        label: 'Grantor Last Name',
        'data-help-title': 'Grantor Information',
        'data-help-text': 'The Grantor is the person or business who is making the grant to create the trust. The Grantor can also sometimes be known as the Owner, Trustor, Donor, Settlor, Conservator, Guardian, or Custodian.<br><br>If there is more than one Grantor, list the primary one. Or if all Grantors are equal, list only one.<br><br>The Grantor and Trustee of a trust may sometimes be the same person.',
      }],
      ['socialSecurity', {
        label: 'Grantor Social Security Number',
        'data-help-title': 'Grantor Information',
        'data-help-text': 'The Grantor is the person or business who is making the grant to create the trust. The Grantor can also sometimes be known as the Owner, Trustor, Donor, Settlor, Conservator, Guardian, or Custodian.<br><br>If there is more than one Grantor, list the primary one. Or if all Grantors are equal, list only one.<br><br>The Grantor and Trustee of a trust may sometimes be the same person.',
      }],
      ['verifySocialSecurity', {
        label: 'Grantor Verify SSN',
        'data-help-title': 'Grantor Information',
        'data-help-text': 'The Grantor is the person or business who is making the grant to create the trust. The Grantor can also sometimes be known as the Owner, Trustor, Donor, Settlor, Conservator, Guardian, or Custodian.<br><br>If there is more than one Grantor, list the primary one. Or if all Grantors are equal, list only one.<br><br>The Grantor and Trustee of a trust may sometimes be the same person.',
      }],
      ['suffix', {
        initial: 'DDS',
      }],
    ]),
  },
  {
    legend: 'Trustee',
    fields: new Map([
      ['trusteeFirstName', {
        component: TextInput,
        label: 'Trustee First Name',
        title: 'Please provide a valid name',
        'data-help-title': 'Trustee Information',
        'data-help-text': 'A Trustee manages the assets of the Trust. There may be more than one Trustee (but only list one).',
        validation: Yup.string().required('Please provide a valid name'),
      }],
      ['trusteeMiddleName', {
        component: TextInput,
        label: 'Trustee Middle Name',
        placeholder: 'Optional',
        'data-help-title': 'Trustee Information',
        'data-help-text': 'A Trustee manages the assets of the Trust. There may be more than one Trustee (but only list one).',
        validation: Yup.string(),
      }],
      ['trusteeLastName', {
        component: TextInput,
        label: 'Trustee Last Name',
        title: 'Please provide a valid name',
        'data-help-title': 'Trustee Information',
        'data-help-text': 'A Trustee manages the assets of the Trust. There may be more than one Trustee (but only list one).',
        validation: Yup.string().required('Please provide a valid name'),
      }],
      ['trusteeTitle', {
        component: TextInput,
        label: 'Trustee Title',
        placeholder: 'Trustee',
        title: 'Please provide a valid title',
        'data-help-title': 'Trustee Information',
        'data-help-text': 'A Trustee manages the assets of the Trust. There may be more than one Trustee (but only list one).',
        validation: Yup.string().required('Please provide a valid title'),
      }],
    ]),
  },
  {
    legend: 'Trustee Address Information',
    fields: new Map([
      ['businessAddress', {
        label: 'Trustee Address',
      }],
      ['businessCity', {
        label: 'Trustee City',
      }],
      ['businessState', {
        label: 'Trustee State',
      }],
      ['businessZip', {
        label: 'Trustee Zip Code',
      }],
      ['businessCounty', {
        label: 'Trustee County',
      }],
      ['mailingAddressDiff', {
        label: 'Mailing address different than Business address?',
      }],
    ]),
  },
  {
    legend: 'Trust Dates',
    fields: new Map([
      ['businessDateStart', {
        label: 'Date business started or acquired',
      }],
      ['businessClosingMonth'],
    ]),
  },
  {
    legend: 'Contact Information',
    fields: new Map([
      ['customerContactPhone'],
      ['customerContactEmail', {
        label: 'Contact E-mail',
      }],
      ['customerContactEmailVerify', {
        label: 'Verify Contact E-mail'
      }],
    ]),
  },
];


const TrustApplicationPage = props => (
  <ApplicationFlow
    step={2}
    title="Trust Application"
    documentType={documentTypes.TRUST}
    description={Description}
    fieldSets={fieldSets}
    {...props}
  />
);

export default TrustApplicationPage;



// WEBPACK FOOTER //
// ./src/pages/trust-application.js